import React from 'react';
import ReactDOM from 'react-dom';
import ComplianceAggrement from './complianceAggrement';
import MsTeamsPrivacyNotifiation from './MsTeamsPrivacyPolicy';

window.complianceACKModal = (data: any) => ReactDOM.render(
<ComplianceAggrement {...data} />,
 document.getElementById('app-portal-container')
)

window.privacyNotificationModal = (data: any) => ReactDOM.render(
    <MsTeamsPrivacyNotifiation {...data} />,
    document.getElementById('app-portal-container')
)